var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],staticClass:"d-none",attrs:{"aria-hidden":"true"}},[_c('div',{ref:"title"},[_vm._t("title")],2),_vm._v(" "),_c('div',{ref:"content"},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e65b3faa","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/bootstrap-vue/es/components/popover/popover.vue
// module id = 1113
// module chunks = 75